import API from "../constants/api.constant";
import { responseErrorHandling } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

export const createEmployee = async (payload: Object) => {
  try {
    const response = await axiosInstance.post(
      API.CREATE_EMPLOYEE_PROFILE,
      payload
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const getEmployees = async (payload: Object) => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_EMPLOYEE, {
      params: payload,
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const deleteEmployeeById = async (id: string) => {
  try {
    const response = await axiosInstance.delete(API.DELETE_EMPLOYEE + id);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

export const updateEmployee = async (id:string, payload: object) => {
    try {
    const response = await axiosInstance.patch(API.UPDATE_EMPLOYEE + id, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

export const blockEmployee = async (id:string, payload: object) => {
    try {
    const response = await axiosInstance.patch(API.BLOCK_EMPLOYEE + id, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

// change Employee password
export const changeEmployeePassword = async ( id: string, data: object) => {
 try {
  const response = await axiosInstance.put(API.EMPLOYEE_PASSWORD_CHANGE + id, data);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// get Employee profile
export const getEmployeeProfile = async ( id: string) => {
 try {
  const response = await axiosInstance.get(API.GET_EMPLOYEE_PROFILE + id);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// update Employee profile
export const updateEmployeeProfile = async (id: string, data: object) => {
 try {
  const response = await axiosInstance.patch(API.UPDATE_EMPLOYEE + id, data);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// employee invitations link
export const employeeInvitationLink = async (businessId: string) => {
 try {
   const response = await axiosInstance.get(API.EMPLOYEE_INVITATION_LINK + businessId);
   return response.data;
 } catch (error) {
    responseErrorHandling(error)
 }
}

// send employee registration invite
export const sendRegisterInvitationEmployee = async (data: object) => {
  try {
   const response = await axiosInstance.post(API.SEND_REGISTER_INVITE_EMPLOYEE, data);
   return response.data;
  } catch (error) {
    responseErrorHandling(error)
  }
}